import MuiGrid from '@mui/material/Grid';
import React from "react";

export const Grid = React.forwardRef(({ text, sx = {}, ...otherProps }, ref) => (
  <MuiGrid sx={{ textAlign: text, ...sx, }} {...otherProps} ref={ref} />
));
